const isModalOpen = state => state.isModalOpen
const type = state => state.type
const surveyId = state => state.surveyId

export default {
  isModalOpen,
  type,
  surveyId
}
